.responsive-iframe{position:relative;width:100%;height:100%;padding-top:56.25%;overflow:hidden}.responsive-iframe iframe{position:absolute;top:0;left:0;width:100%;height:100%;border:none;overflow:hidden;z-index:9999}
/*# sourceMappingURL=power-bi-graph.component-GWTQ4TW7.css.map */
